import { render } from "./MenuListItemPopup.vue?vue&type=template&id=ce1f90c8"
import script from "./MenuListItemPopup.vue?vue&type=script&lang=js"
export * from "./MenuListItemPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__